module.exports = __webpack_public_path__ + "static/media/firstWitness.9cfddf5c.webp";